import { AppBar, Box, Button, Dialog, DialogContent, DialogActions, Toolbar, Typography } from '@mui/material';
import UploadArquivo from './UploadArquivo';
import { AddBox, Cancel } from '@mui/icons-material';
import { inject, observer } from 'mobx-react';
import { action, makeObservable, observable } from 'mobx';
import ReactComponent from '../ReactComponent';
import DocumentoRepresentante from './DocumentoRepresentante';

class SustentacaoOralEletronicaDialog extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            open: observable,
            documentosSelecionados: observable,
            handleOpen: action,
            handleClose: action,
            handleUpload: action,
            handleIncluirArquivosInscricao: action,
            handleRemoveDocumento: action
        });
    }

    open = false;
    documentosSelecionados = this.observableProps.documentos;

    handleOpen = () => {
        this.open = true;
    };

    handleClose = () => {
        this.open = false;
    };

    handleUpload = async (file, handleProgresso) => {
        const dadosDocumento = await this.advogadoSustentacaoOralService.uploadDocumento(file, handleProgresso);
        this.documentosSelecionados = [...this.observableProps.documentos, dadosDocumento];
    };

    handleIncluirArquivosInscricao = () => {
        this.handleClose();
        this.observableProps.onSelect(this.documentosSelecionados);
    };

    handleRemoveDocumento = (id) => {
        this.documentosSelecionados = (documentos) => documentos.filter((documento) => documento.id !== id);
    };

    render() {
        return (
            <>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                    <Button
                        sx={{ whiteSpace: 'nowrap', minWidth: 'auto', mr: 1, ml: 2, width: '200px' }}
                        variant="contained"
                        onClick={this.handleOpen}
                        aria-label="Incluir arquivos"
                        endIcon={<AddBox />}
                    >
                        Incluir arquivos
                    </Button>
                </Box>
                {this.open && (
                    <Dialog
                        open={true}
                        onClose={this.handleClose}
                        sx={{ width: '80wh' }}
                        maxWidth={false}
                        PaperProps={{
                            sx: {
                                width: '100%',
                                minWidth: '80vw'
                            }
                        }}
                    >
                        <AppBar sx={{ position: 'relative' }}>
                            <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                Seleção de arquivos para sustentação oral eletrônica
                            </Toolbar>
                        </AppBar>
                        <DialogContent sx={{ height: '80vh' }}>
                            <Typography sx={{ mt: 2, mb: 1, fontSize: 20, fontWeight: 500 }}>
                                Arquivos enviados
                            </Typography>
                            {this.documentosSelecionados.length === 0 ? (
                                <Typography sx={{ textAlign: 'center' }}>
                                    Não há documentos enviados disponíveis.
                                </Typography>
                            ) : (
                                this.documentosSelecionados.map(
                                    ({ id, nome, dataDocumento, excluido, documentoValidacao }) => (
                                        <DocumentoRepresentante
                                            key={id}
                                            id={id}
                                            nome={nome}
                                            dataDocumento={dataDocumento}
                                            excluido={excluido}
                                            documentoValidacao={documentoValidacao}
                                            onRemoveDocumento={() => this.handleRemoveDocumento(id)}
                                        />
                                    )
                                )
                            )}

                            <Typography sx={{ mt: 2, mb: 1, fontSize: 20, fontWeight: 500 }}>
                                Enviar novo arquivo
                            </Typography>
                            <UploadArquivo onUploadDocumento={this.handleUpload} />
                        </DialogContent>
                        <DialogActions sx={{ display: 'flex', justifyContent: 'flex-end', mx: 2 }}>
                            <Button
                                color="secondary"
                                variant="outlined"
                                onClick={this.handleIncluirArquivosInscricao}
                                data-testid="closeDialog"
                                endIcon={<Cancel />}
                            >
                                Fechar
                            </Button>
                        </DialogActions>
                    </Dialog>
                )}
            </>
        );
    }
}

export default inject('stores')(observer(SustentacaoOralEletronicaDialog));
